import { Patient } from "./patient";

export interface PatientListItem {
  id: number;
  fullname: string;
  tutor_name?: string;
  id_card: number;
  id_number: number;
  email: string;
  phone_number: number;
  pathologies: string[];
  status: 'active' | 'inactive';
}

// Interface for patient list request
export interface PatientListRequest {
    patient_id: number;
  }
  
  // Interface for patient list response
  export interface PatientListResponse {
    patient_id: number;
    data: Patient;
  }